<template>
	<div class="wrap" @click="goAnalysis">
		<cardHead title='养殖概况'></cardHead>
		<div class="card-body">
			<div id="lineChart1"></div>
			<div class="tag-list">
				<div class="tag">
					<span class="tag-value">743</span>
					<span class="tag-label">配种数</span>
				</div>
				<div class="tag" style="margin: 0 0.9rem;">
					<span class="tag-value">67</span>
					<span class="tag-label">新产数</span>
				</div>
				<div class="tag">
					<span class="tag-value">3</span>
					<span class="tag-label">死亡/淘汰数</span>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
import cardHead from './cardHead.vue'
export default {

	components: {
		cardHead
	},
	data() {
		return {
			day1: [{
				title: '配种数',
				month: [],
				value: [42, 34, 31, 24, 26, 36, 46]
			},
			{
				title: '新产数',
				month: [],
				value: [13, 20, 38, 38, 20, 30, 30]
			},
			],

		};
	},
	mounted() {
		// 获取近七日
		this.getDays()
	},

	methods: {
		// 近七日
		getDays() {
			this.$http({
				url: 'screenapp-service/aErShan/seven/days',
				//请求方式
				method: 'get',
				//传递的参数
				data: {

				},
			}).then(res => {
				const data = res.data;
				if (res.data.code === 200) {
					this.day1.forEach((item) => {
						item.month = data.result
					})
					this.setLineData(this.day1, 'lineChart1')
				} else {
					// this.$message.error(data);
				}
			})

		},
		goAnalysis() {
			this.$router.push({ name: 'analysis' })
		},
		setLineData(data, dom) {
			const colors = ['#00FEFF', '#FFF200', '#40FF00'];
			const legend = [];
			const series = [];
			let xAxis = [];
			let seriesColors = [
				{ color0: 'rgba(0,246,236,0.48)', color1: 'rgba(91,233,255,0)' },
				{ color0: 'rgba(255,217,28,0.48)', color1: 'rgba(91,233,255,0)' }
			];
			data.forEach((item, index) => {
				legend.push({
					name: item.title,
					textStyle: {
						color: '#FFFFFF',
						fontSize: '0.13rem'
					},
					// icon: 'roundRect',
					// itemWidth: 4,
					// itemhight: 4,
				})
				xAxis = item.month
				series.push({
					name: item.title,
					type: "line",
					showSymbol: false,
					areaStyle: {
						color: {
							type: 'linear',
							x: 0,
							y: 0,
							x2: 0,
							y2: 1,
							colorStops: [{
								offset: 0,
								color: seriesColors[index].color0 // 0% 处的颜色
							}, {
								offset: 1,
								color: seriesColors[index].color1 // 100% 处的颜色
							}],
							global: false // 缺省为 false
						}
					},
					lineStyle: {
						width: 2,
					},
					color: colors[index],
					data: item.value,
				})
			})
			const line = {
				dom,
				xAxis,
				legend: {
					data: legend,
					// x: 'right',
					// y: 'top',
					top: "0%",
					right: "3%",
					icon: 'rectangle',
					itemWidth: 15,
					itemHeight: 2,
					padding: [10, 0, 0, 0],
				},
				series: series
			}
			this.lineChart(line)
		},

		lineChart(data) {
			this.chart = this.$echarts.init(document.getElementById(data.dom))
			// 隐藏动画加载效果。
			var option = {
				color: ['#FFF200', '#00FEFF', '#FFF200'],
				tooltip: {
					trigger: 'axis',
					padding: [5, 20],
					backgroundColor: 'rgba(255,255,255,0.8)',
					// borderColor: 'rgba(18, 36, 132, 1)',
					borderColor: '#292929',
					borderWidth: 1,
					textStyle: {
						color: '#050F37',
					},
				},
				legend: data.legend,
				grid: {
					top: '20%',
					left: '5%',
					right: '4%',
					bottom: '10%',
					containLabel: true,
				},
				xAxis: {
					type: 'category',
					boundaryGap: true,

					axisLabel: {
						color: '#00FEFF',
						fontSize: '0.1rem',
					},
					axisLine: {
						symbol: ['none', 'arrow'],
						show: true, // X轴 网格线 颜色类型的修改
						symbolOffset: [0, 6],
						symbolSize: [6, 6],
						lineStyle: {
							color: 'rgba(0,254,255,0.2)',
							type: 'solid',
						},
					},
					axisTick: {
						// X轴线 刻度线
						show: true,
						inside: false,
						alignWithLabel: true
					},
					data: data.xAxis,
				},
				yAxis: {
					name: '单位：只',
					nameTextStyle: {
						color: '#00FEFF',
						padding: [3, 10, 0, 0],
						fontSize: '0.1rem',
					},
					max: 50,
					scale: false,
					type: 'value',
					splitNumber: 5,
					boundaryGap: [0, 1],
					axisLine: {
						symbol: ['none', 'arrow'],
						show: true, // X轴 网格线 颜色类型的修改
						symbolOffset: [0, 6],
						symbolSize: [6, 6],
						lineStyle: {
							color: 'rgba(0,254,255,0.2)',
							type: 'solid',
						},
					},
					splitLine: {
						lineStyle: {
							type: 'soild',
							color: 'rgba(0,254,255,0.02)'
						}
					},
					axisLabel: {

						color: '#00FEFF',
						fontSize: '0.1rem',
					},
				},
				series: data.series,
			}
			this.chart.clear();
			this.chart.setOption(option)
			window.addEventListener('resize', () => {
				this.chart.resize()
			})
		},


	},
};
</script>

<style lang="scss" scoped>
.wrap {
	width: 12.45rem;
	height: 3.13rem;
	background: url('../../../assets/yq/rectangle3.png');
	background-size: contain;
	cursor: pointer;

	.card-body {
		display: flex;
		align-items: center;

		.tag-list {
			display: flex;
			align-items: center;
			justify-content: space-around;

			margin-right: 0.53rem;

			.tag:hover {
				transform: scale3d(1.1, 1.1, 1.1)
			}

			.tag {
				width: 1.81rem;
				height: 1.31rem;


				display: flex;
				flex-direction: column;
				justify-content: space-around;
				align-items: center;
				animation-name: FadeIn;
				animation-duration: 2s;
				animation-direction: alternate;
				animation-iteration-count: infinite;

				.tag-label {
					font-size: 0.18rem;
					font-family: Source Han Sans CN-Regular, Source Han Sans CN;
					font-weight: 400;
					color: #021550;
				}

				.tag-value {
					font-size: 0.33rem;
					font-family: Impact-Regular, Impact;
					font-weight: 400;
					color: #FFFFFF;


				}
			}
		}
	}
}

@keyframes FadeIn {
	0% {
		background: url('../../../assets/yq/circle.png');
		background-size: contain;
		// transform: rotate3d(1, 0, 0, -12deg);
	}

	25% {
		background: url('../../../assets/yq/circle3.png');
		background-size: contain;
		// transform: rotate3d(1, 0, 0,12deg);
	}

	50% {
		background: url('../../../assets/yq/circle.png');
		background-size: contain;
		// transform: rotate3d(1, 0, 0, -12deg);
	}

	75% {
		background: url('../../../assets/yq/circle3.png');
		background-size: contain;
		// transform: rotate3d(1, 0, 0, 12deg);
	}

	100% {
		background: url('../../../assets/yq/circle.png');
		background-size: contain;
		// transform: rotate3d(1, 0, 0, -12deg);
	}

	// transform: rotate3d(0, 1, 1, 0deg);
}

#lineChart1 {


	flex: 1;
	height: 2.3rem;
	margin-top: .34rem;
}
</style>